import {Component} from 'san';
import styles from './styles.module.less';

export default class TtsBtn extends Component {
    static template = require('./index.html');

    initData() {
        return {
            styles,
            loading: false,
        };
    }

    static computed = {
        followTip() {
            const followed = this.data.get('followed');
            return !!+followed ? '已关注' : '关注';
        },
    };

    handleClickFollow() {
        const followed = this.data.get('followed');
        this.storeDispatch('update:follow', followed);
    }
}